import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'fr',
    conver: 'fr-FR',
    alia: 'fr',
    region: 'France',
    regionText: 'France',
    language: 'French',
    languageText: 'français',
    appId: 6,
    acceptLanguage: 'fr-FR,fr;q=0.9',
};
export default theLocale;
